import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import HowItWorks from '../views/HowItWorks'
import Contact from '../views/Contact'
import Affiliate from '../views/Affiliate'
import Deposite from '../views/Deposite'
import Trades from '../views/Trades'
import Exchange from '../views/Exchange'
import Liquidity from '../views/Liquidity';
import Faq from '../views/Faq'
import Terms from '../views/Terms'
import 'bootstrap'
import VueToastr from "vue-toastr";
import VTooltip from 'v-tooltip'

Vue.use(VueRouter)
Vue.use(VTooltip)
Vue.use(VueToastr)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/how-it-works',
        name: 'how-it-works',
        component: HowItWorks
    },
    {
        path: '/contact',
        name: 'contact',
        component: Contact
    },
    {
        path: '/affiliate',
        name: 'affiliate',
        component: Affiliate
    },
    {
        path: '/deposite',
        name: 'deposite',
        component: Deposite
    },
    {
        path: '/trades',
        name: 'trades',
        component: Trades
    },
    {
        path: '/exchange',
        name: 'exchange',
        component: Exchange
    },
    {
        path: '/liquidity',
        name: 'liquidity',
        component: Liquidity
    },
    {
        path: '/faq',
        name: 'faq',
        component: Faq
    },
    {
        path: '/terms-conditions',
        name: 'terms',
        component: Terms
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
})

export default router
